import { render, staticRenderFns } from "./WebsiteProducts.vue?vue&type=template&id=3e0f40fa&scoped=true&"
import script from "./WebsiteProducts.vue?vue&type=script&lang=js&"
export * from "./WebsiteProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f40fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0f40fa')) {
      api.createRecord('3e0f40fa', component.options)
    } else {
      api.reload('3e0f40fa', component.options)
    }
    module.hot.accept("./WebsiteProducts.vue?vue&type=template&id=3e0f40fa&scoped=true&", function () {
      api.rerender('3e0f40fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/WebsiteProducts.vue"
export default component.exports